export default {
    total: 'Total {count}',
    perPage: '{count}/page',
    goTo: 'Go to',
    go: 'Go',
};
